import linkArrow from "../../../images/link-arrow.png";

import themePalette from "../../../../.brew-cache/theme.json";

export default theme => ({
    para: {
        display: 'block',
        position: 'relative',
        fontSize: 14,
        letterSpacing: '0.024em',
        lineHeight: '2',
        '& a': {
            color: theme.palette.primary.main,
            '&:hover, &:focus': {
                color: theme.palette.primary.dark,
            }
        },
        '&.arrow-link a': {
          fontSize: 16,
          color: theme.palette.primary.main,
          letterSpacing: '0.06em',
          lineHeight: 1.2,
          display: 'inline-block',
          textTransform: 'uppercase',
          textDecoration: 'none',
          fontFamily: theme.headerFont,
          transition: 'color .3s ease-in-out',
          '&::after': {
              width: 26,
              height: 13,
              display: 'inline-block',
              marginLeft: 15,
              backgroundImage: 'url(' + linkArrow + ')',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              content: '""',
              transition: 'margin-left .3s ease-in-out',
          },
          '&:hover, &:focus': {
              color: theme.palette.primary.dark,
              '&::after': {
                  marginLeft: 25,
              }
          }
      },
      '&[data-text-color="primary"]': { color: themePalette.ThemeOptions.mainColours.primaryColour},
      '&[data-text-color="secondary"]': { color: themePalette.ThemeOptions.mainColours.secondaryColour},
      '&[data-text-color="tertiary"]': { color: themePalette.ThemeOptions.mainColours.tertiaryColour},
      '&[data-text-color="foreground_primary"]': { color: themePalette.ThemeOptions.foregroundColours.foregroundPrimaryColour},
      '&[data-text-color="foreground_secondary"]': { color: themePalette.ThemeOptions.foregroundColours.foregroundSecondaryColour},
      '&[data-text-color="foreground_tertiary"]': { color: themePalette.ThemeOptions.foregroundColours.foregroundTertiaryColour},
      '&[data-text-color="background_primary"]': { color: themePalette.ThemeOptions.backgroundColours.backgroundPrimaryColour},
      '&[data-text-color="background_secondary"]': { color: themePalette.ThemeOptions.backgroundColours.backgroundSecondaryColour},
      '&[data-text-color="background_tertiary"]': { color: themePalette.ThemeOptions.backgroundColours.backgroundTertiaryColour},
    },
})